import { render, staticRenderFns } from "./DualAcceptances.vue?vue&type=template&id=2929f6d3&"
import script from "./DualAcceptances.vue?vue&type=script&lang=js&"
export * from "./DualAcceptances.vue?vue&type=script&lang=js&"
import style0 from "./DualAcceptances.vue?vue&type=style&index=0&id=2929f6d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports